export enum HttpStatusCodes {
	ModelStateError = -1,
	Ok = 200,
	BadRequest = 400,
	Unauthorized = 401,
	Forbidden = 403,
	NotFound = 404,
	ConflictError = 409,
	ServerError = 500,
	ServiceUnavailable = 503,
}
